import { configureStore } from '@reduxjs/toolkit';
import loginReducer from './slices/auth/LoginSlice';
import logoutReducer from './slices/auth/LogoutSlice';
import usersCountReducer from './slices/user-management/CountSlice';
import usersListReducer from './slices/user-management/GetUsersListSlice';
import profileReducer from './slices/profile/GetProfileSlice';
import contentCountReducer from './slices/content-management/CountSlice';
import updateUserStatusReducer from './slices/user-management/UpdateStatusSlice';
import deleteUserReducer from './slices/user-management/DeleteUserSlice';
import contentPostsReducer from './slices/content-management/PostsSlice';
import deleteContentReducer from './slices/content-management/DeleteContentSlice';
import updatePostStatusReducer from './slices/content-management/UpdateStatusSlice';
import dashboardReducer from './slices/dashboard/GetDashboardDataSlice';
import getEventsReducer from './slices/event-management/GetEventsSlice';
import getEventsCountReducer from './slices/event-management/GetEventsCountSlice';
import createEventReducer from './slices/event-management/CreateEventSlice';
import userDetailReducer from './slices/user-management/UserDetailSlice';
import deleteEventReducer from './slices/event-management/DeleteEventSlice';
import getSportsListReducer from './slices/event-management/GetSportsListSlice';
import markFeatureReducer from './slices/event-management/MarkFeatureSlice';
import removeMediaReducer from './slices/content-management/RemoveMediaSlice';
import getEventDetailReducer from './slices/event-management/EventDetailSlice';
import editEventReducer from './slices/event-management/EditEventSlice';
import problemReportsReducer from './slices/support/ProblemReportsSlice';
import resolveReportReducer from './slices/support/ResolveReportSlice';

export const store = configureStore({
    reducer: {
        login: loginReducer,
        logout: logoutReducer,
        usersCount: usersCountReducer,
        usersList: usersListReducer,
        updateUserStatus: updateUserStatusReducer,
        deleteUser: deleteUserReducer,
        profileData: profileReducer,
        contentCount: contentCountReducer,
        contentPosts: contentPostsReducer,
        deleteContent: deleteContentReducer,
        updatePostStatus: updatePostStatusReducer,
        dashboard: dashboardReducer,
        getEvents: getEventsReducer,
        getEventsCount: getEventsCountReducer,
        createEvent: createEventReducer,
        userDetail: userDetailReducer,
        deleteEvent: deleteEventReducer,
        getSportsList: getSportsListReducer,
        markFeature: markFeatureReducer,
        removeMedia: removeMediaReducer,
        getEventDetail: getEventDetailReducer,
        editEvent: editEventReducer,
        problemReports: problemReportsReducer,
        resolveReport: resolveReportReducer,
    }
})